module.exports = __webpack_public_path__ + "static/media/UntrashWhiteIcon.9b99d219.svg";